import { AxiosError } from 'axios';
import http from './http'; // axios instance configured elsewhere

export interface NotificationData {
  type: string;
  module: string;
  manager: string;
  benefits: string;
}

export interface INotification extends NotificationData {
  createdAt: string;
  id: string;
  date: string;
  // Add other fields if required
}

class NotificationService {
  static createGlobalNotification(data: NotificationData): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      http
        .post('/notifications/global', data)
        .then(() => resolve())
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          } else {
            reject(error);
          }
        });
    });
  }

  static fetchGlobalNotifications(): Promise<INotification[]> {
    return new Promise<INotification[]>((resolve, reject) => {
      http
        .get('/notifications/global')
        .then(response => {
          resolve(response.data);
        })
        .catch((error: AxiosError) => {
          if (error.response && error.response.data && error.response.data.message) {
            reject(new Error(error.response.data.message));
          } else {
            reject(error);
          }
        });
    });
  }
}

export default NotificationService;
